(function () {
  var d = document, calme = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $$ = function (s, r) { return [].slice.call((r || d).querySelectorAll(s)); };
  function memo(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }

  // Compte à rebours : vers une date fixe, jamais relancé. À zéro, il disparaît.
  var comptes = $$('[data-sol-compte]');
  function deux(n) { return (n < 10 ? '0' : '') + n; }
  function tic() {
    comptes.forEach(function (c) {
      var r = new Date(c.getAttribute('data-sol-compte')) - Date.now();
      if (r <= 0) { c.hidden = true; if (c.tagName === 'SPAN') c.textContent = c.getAttribute('data-fini') || ''; return; }
      var j = Math.floor(r / 864e5), h = Math.floor(r / 36e5) % 24, m = Math.floor(r / 6e4) % 60, s = Math.floor(r / 1e3) % 60;
      if (c.tagName === 'SPAN') { c.textContent = j + ' j ' + deux(h) + ' h ' + deux(m) + ' min ' + deux(s) + ' s'; return; }
      var u = c.querySelectorAll('b');
      u[0].textContent = j; u[1].textContent = deux(h); u[2].textContent = deux(m); u[3].textContent = deux(s);
    });
  }
  if (comptes.length) { tic(); setInterval(tic, 1000); }

  // Bandeau : le message sort par le haut, le suivant arrive par le bas.
  $$('[data-sol-bandeau]').forEach(function (b) {
    var m = $$('.sol-bandeau__m', b), i = 0;
    if (m.length < 2) return;
    setInterval(function () {
      if (d.hidden) return;
      var a = m[i];
      i = (i + 1) % m.length;
      var s = m[i];
      s.style.transition = 'none';
      s.classList.remove('is-parti', 'is-la');
      s.offsetWidth;
      s.style.transition = '';
      a.classList.remove('is-la');
      a.classList.add('is-parti');
      s.classList.add('is-la');
    }, 3800);
  });

  // Profils
  $$('[data-sol-profils]').forEach(function (r) {
    var o = $$('[role=tab]', r), p = $$('[role=tabpanel]', r);
    o.forEach(function (b, i) {
      b.addEventListener('click', function () {
        o.forEach(function (x, j) { x.setAttribute('aria-selected', j === i); p[j].hidden = j !== i; });
      });
    });
  });

  // Cartes qui se retournent : la première se laisse deviner une fois.
  $$('.sol-carte3d').forEach(function (c, i) {
    c.addEventListener('click', function () { c.setAttribute('aria-pressed', c.getAttribute('aria-pressed') !== 'true'); });
  });
  $$('.sol-fl__grille').forEach(function (g) {
    var c = g.querySelector('.sol-carte3d');
    if (!c || calme || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { c.classList.add('is-apercu'); io.disconnect(); } }, { threshold: .6 });
    io.observe(c);
  });

  // Comparaison
  $$('[data-sol-compare]').forEach(function (z) {
    var r = z.querySelector('input');
    r.addEventListener('input', function () { z.style.setProperty('--pos', r.value + '%'); });
  });

  // Anneau d'images
  $$('[data-sol-anneau]').forEach(function (s) {
    var roue = s.querySelector('.sol-an__roue'), el = $$('.sol-an__el', s), n = el.length;
    if (!n) return;
    var a = 0, glisse = false, x0 = 0, vu = false, dernier = 0;
    function poser() {
      var l = el[0].offsetWidth, rayon = Math.round((l + 26) / (2 * Math.tan(Math.PI / n)));
      el.forEach(function (e, i) { e.style.transform = 'rotateY(' + (i * 360 / n) + 'deg) translateZ(' + rayon + 'px)'; });
      roue.style.setProperty('--r', rayon + 'px');
    }
    poser();
    addEventListener('resize', poser);
    function tourne() { roue.style.transform = 'translateZ(calc(var(--r) * -1)) rotateY(' + a + 'deg)'; }
    tourne();
    new IntersectionObserver(function (e) { vu = e[0].isIntersecting; }).observe(s);
    function img(t) {
      requestAnimationFrame(img);
      var dt = dernier ? t - dernier : 16;
      dernier = t;
      if (vu && !glisse && !calme) { a -= dt * .008; tourne(); }
    }
    requestAnimationFrame(img);
    s.addEventListener('pointerdown', function (e) { glisse = true; x0 = e.clientX; s.setPointerCapture(e.pointerId); });
    s.addEventListener('pointermove', function (e) { if (glisse) { a += (e.clientX - x0) * .32; x0 = e.clientX; tourne(); } });
    ['pointerup', 'pointercancel'].forEach(function (t) { s.addEventListener(t, function () { glisse = false; }); });
  });

  // Réglage : deux questions, un programme et un niveau de départ.
  $$('[data-sol-quiz]').forEach(function (q) {
    var et = $$('[data-etape]', q), res = q.querySelector('[data-res]'), prog = null;
    function montre(n) { et.forEach(function (e, i) { e.hidden = i !== n; }); res.hidden = n < et.length ? true : false; }
    $$('[data-prog]', q).forEach(function (b) {
      b.addEventListener('click', function () { prog = b; montre(1); });
    });
    $$('[data-niveau]', q).forEach(function (b) {
      b.addEventListener('click', function () {
        res.querySelector('[data-r-prog]').textContent = prog.dataset.prog;
        res.querySelector('[data-r-txt]').textContent = prog.dataset.txt + ' ' + b.dataset.niveau;
        montre(et.length);
        res.focus();
      });
    });
    var re = q.querySelector('[data-reprendre]');
    re && re.addEventListener('click', function () { montre(0); });
  });

  // Barre d'achat : visible après le héros, retirée devant l'offre.
  var col = d.querySelector('.sol-collant');
  if (col) {
    var heros = d.querySelector('.sol-h2'), offre = d.querySelector('.sol-of'), h = true, o = false;
    var maj = function () { col.classList.toggle('is-la', !h && !o); };
    if (heros) new IntersectionObserver(function (e) { h = e[0].isIntersecting; maj(); }).observe(heros); else h = false;
    if (offre) new IntersectionObserver(function (e) { o = e[0].isIntersecting; maj(); }).observe(offre);
  }

  // Une question ?
  $$('.sol-aide').forEach(function (a) {
    var b = a.querySelector('.sol-aide__b'), p = a.querySelector('.sol-aide__p');
    function bascule(v) { p.hidden = !v; b.setAttribute('aria-expanded', v); }
    b.addEventListener('click', function () { bascule(p.hidden); });
    a.querySelector('.sol-aide__x').addEventListener('click', function () { bascule(false); b.focus(); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !p.hidden) bascule(false); });
  });

  // Pop-up e-mail : une seule fois, après 30 s ou la moitié de la page.
  var nl = d.querySelector('[data-sol-nl]');
  if (nl) {
    var deja = memo('solNl') || location.search.indexOf('customer_posted') > -1;
    var parti = false, av = null;
    var ouvre = function () {
      if (parti || deja) return;
      var ban = d.getElementById('shopify-pc__banner');
      if (d.documentElement.classList.contains('sol-cn') || (ban && ban.offsetHeight > 0)) { setTimeout(ouvre, 8000); return; }
      parti = true;
      av = d.activeElement;
      nl.hidden = false;
      memo('solNl', '1');
      var c = nl.querySelector('input[type=email]');
      c && c.focus({ preventScroll: true });
    };
    var ferme = function () { nl.hidden = true; av && av.focus && av.focus({ preventScroll: true }); };
    $$('[data-nl-x]', nl).forEach(function (x) { x.addEventListener('click', ferme); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !nl.hidden) ferme(); });
    if (location.search.indexOf('customer_posted') > -1) { nl.hidden = false; }
    else if (!deja) {
      setTimeout(ouvre, 30000);
      addEventListener('scroll', function f() {
        if (scrollY > (d.documentElement.scrollHeight - innerHeight) * .5) { removeEventListener('scroll', f); ouvre(); }
      }, { passive: true });
    }
  }
})();
